const GET_PB_TEMPLATE_STATUS = `
  query {
    pageBuilderTemplateSet @client
    pageBuilderTemplateId @client
  }
`;

const MERGE_PB_TEMPLATE_CHANGES = `
  query mergePageBuilderTemplateChanges($parent: MergePageBuilderTemplateChangesParent!, $entityIdentifier: String!) {
    mergePageBuilderTemplateChanges(parent: $parent, entityIdentifier: $entityIdentifier)
  }
`;

const GET_PB_TEMPLATE = `
query getActivePageBuilderTemplate($id: String!) {
  getActivePageBuilderTemplate(id: $id)
}
`;

export { GET_PB_TEMPLATE_STATUS, MERGE_PB_TEMPLATE_CHANGES, GET_PB_TEMPLATE };
